import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/tax-offices',
    name: 'tax_offices_list',
    component: () => import('@/views/pages/tax-offices/TaxOfficesList.vue'),
    meta: {
      pageTitle: 'Tax Offices List',
      breadcrumb: {
        label: 'Tax Offices List'
      },
      roles: [ROLES.ADMIN]
      // verticalMenu: {
      //   title: 'Tax Offices List',
      //   icon: 'PenToolIcon',
      //   parent: 'settingsGroup'
      // }
    }
  }
];
